import SearchBarWithFilter from './SearchBarWithFilter';

export default SearchBarWithFilter;
